<!-- -------------------------------------------------------------
     1️⃣  SPLASH SCREEN (visible only while showSplash === true)
     ------------------------------------------------------------- -->
<div *ngIf="showSplash" class="splash-screen">
  <div class="text-center">
    <!-- You can replace this with your own logo or an animated SVG -->
    <img
      src="assets/icons/icon-512x512.png"
      alt="App logo"
      class="splash-logo mb-4"
    />

    <!-- Bootstrap spinner – feel free to change colour / size -->
    <div class="spinner-border text-success" role="status">
      <span class="visually-hidden">Loading…</span>
    </div>
  </div>
</div>
<!-- -------------------------------------------------------------
     2️⃣  MAIN LAYOUT (rendered after the splash disappears)
     ------------------------------------------------------------- -->
<div *ngIf="!showSplash" class="d-flex flex-column flex-lg-row min-vh-100">
  <!-- Main content area -->
  <main class="flex-fill">
    <router-outlet></router-outlet>
    <!-- Notification component (kept exactly as you already had) -->
    <simple-notifications></simple-notifications>
  </main>
</div>
